// extracted by mini-css-extract-plugin
export var footer = "_ox-0";
export var inherit = "_ox-1";
export var input = "_ox-2";
export var modalContent = "_ox-3";
export var quillEditor = "_ox-4";
export var subtitle = "_ox-5";